<template>
  <dashboard-template>
    <template slot="dashboard-header">
      <div class="d-flex justify-content-between align-items-center w-100">
        <h6 class="mb-0">{{ $t('projects.create_project') }}</h6>
        <img class="tooltip-icon icon-small mr-3" id="tooltip-project-create" v-bind:src="'/app/images/icons/info.svg'" />
        <b-popover target="tooltip-project-create" variant="warning" triggers="hover" placement="bottomleft">
          <div v-html="$t('tooltips.project_create')"></div>
        </b-popover>
      </div>
    </template>
    <template slot="dashboard-body">
      <div class="dashboard-content">
        <div class="d-flex align-items-center w-100">
          <p class="mb-0 project-create-label">{{ $t('projects.new_project_name') }}</p>
          <div class="project-create-input-container">
            <input v-model="projectName" class="form-control mr-4 w-100" name="projectName" type="text">
          </div>
          <button type="button" class="btn btn-large btn-orange ml-4" @click="addProject" :disabled="!isValid">
            <save-icon></save-icon>
            <span>{{ $t('projects.save_project') }}</span>
          </button>
        </div>
      </div>
    </template>
  </dashboard-template>
</template>

<script>
import axios from 'axios'
import DashboardTemplate from '@/views/Dashboard'
import { SaveIcon } from 'vue-feather-icons'

export default {
  name: 'ProjectCreate',

  data () {
    return {
      projectName: null
    }
  },

  methods: {
    addProject () {
      axios.post(process.env.VUE_APP_API_ENDPOINT + '/data/projects/add', {
        name: this.projectName,
        active: true
      })
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.$emit('onProjectCreate', response.data)
            this.$cookies.set('last_used_project_id', response.data.id)
            this.$router.push({ name: 'source.create', params: { projectId: response.data.id } })
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$router.push({ name: 'auth.error', params: { errorCode: error.response.data.statusCode, errorMessage: error.response.data.message } })
          }
        })
    }
  },

  computed: {
    isValid () {
      if ((this.projectName) !== '' && (this.projectName !== null)) return true
      else return false
    }
  },

  components: { DashboardTemplate, SaveIcon }
}
</script>
